// Push custom events to GTM dataLayer
export const trackEvent = (event, details = {}) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event,
      ...details,
    });
  };
  
  // Track user engagement
  export const trackEngagement = (action, label) => {
    trackEvent('user_engagement', { action, label });
  };
  
  // Track button clicks
  export const trackButtonClick = (buttonName) => {
    trackEvent('button_click', { buttonName });
  };
  
  // Track form submissions
  export const trackFormSubmission = (formName) => {
    trackEvent('form_submission', { formName });
  };
  
  // Track navigation items
  export const trackNavigation = (menuItem) => {
    trackEvent('navigation_click', { menuItem });
  };